import React, {useCallback, useState} from "react";
import styled from "@emotion/styled";
import {Modal, ModalButtons, ModalText, ModalTitle, PrimaryButton} from "components/Common";
import {IconError} from "components/Icons";
import {useTranslation} from "react-i18next";
import {closeApplication} from "modules/utils/helpers";
import {IS_APP_DISABLED} from "modules/constants";
import {some} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {actionEnableGodMode} from "modules/actions";
import {getGodModeEnable} from "modules/selectors";
import RallySSO from "modules/utils/SSO/rallySSO";
import {Exists} from "components/Exists";

const Wrapper = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: ${({theme}) => theme.colors.brand.black};
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px;

	> div {
		border: 2px solid ${({theme}) => theme.colors.brand.primary};
	}

	.title {
		margin-top: 20px;
	}
`;

const ClickArea = styled.div`
	width: 60px;
	height: 60px;
	position: absolute;
	bottom: 0;
	left: 0;
	background: transparent;
`;

interface IProps {
	children: React.ReactNode;
}

export const HOCDisabled: React.FC<IProps> = ({children}) => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const isGodMode = useSelector(getGodModeEnable);
	const [godModeIndicator, setGodModeIndicator] = useState(0);
	const isAvailable = some([!IS_APP_DISABLED, isGodMode]);

	const exitApp = useCallback(() => {
		closeApplication();
	}, []);

	const enableGodMode = () => {
		setGodModeIndicator(1 + godModeIndicator);
		if (godModeIndicator >= 10) {
			dispatch(actionEnableGodMode());
		}
	};

	if (isAvailable) {
		return <React.Fragment>{children}</React.Fragment>;
	}

	return (
		<Wrapper>
			<Modal>
				<IconError width={120} height={120} />

				<ModalTitle className="title">{t("modal.disabled.title")}</ModalTitle>
				<ModalText>{t("modal.disabled.text")}</ModalText>

				<Exists when={!RallySSO.IS_NATIVE}>
					<ModalButtons>
						<PrimaryButton onClick={exitApp}>{t("modal.disabled.close")}</PrimaryButton>
					</ModalButtons>
				</Exists>

				<ClickArea onClick={enableGodMode} />
			</Modal>
		</Wrapper>
	);
};
